import { Component } from '@angular/core';

@Component({
  selector: 'app-center-services',
  templateUrl: './center-services.component.html',
  styleUrl: './center-services.component.scss'
})
export class CenterServicesComponent {

}
